import api from '../api'

const state = {
  all: []
}

const actions = {
  getTags: ({ state, commit }, id) => {
    return api.getAllTags(id).then(tags => {
      return commit('setAllTags', tags)
    })
  },
  getAllTagsCreative: ({ state, commit }, id) => {
    return api.getAllTagsCreative(id).then(tags => {
      return commit('setAllTags', tags)
    })
  },
  getTag: ({ state, commit }, id) => {
    return api.getSingleTag(id)
  },
  deleteTag: ({ state, commit }, id) => {
    return api.deleteSingleTag(id)
  },
  refreshTag: ({ state, commit }, id) => {
    return api.refreshSingleTag(id)
  },
  updateTag: ({ state, commit }, data) => {
    return api.updateSingleTag(data)
  }
}

const mutations = {
  setAllTags (state, tags) {
    state.all = tags
  }
}

const getters = {
  all: state => {
    return state.all
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/tags.js